import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 639A8D4C-086C-4038-A569-F9387E851262
 * name currency-jpy
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-jpy.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CurrencyJpyIcon = createSvgIcon(<><path d="M13.92 11H18V13H13V15H18V17H13V21H11V17H6V15H11V13H6V11H10.08L5 3H7.37L12 10.29L16.63 3H19L13.92 11Z" /></>, 'CurrencyJpyIcon');
export default CurrencyJpyIcon